import { useEffect, useRef } from "react"

import { faIcon } from "@utils/faIcon"

import { Icon } from "@atoms"

import styles from "./UnscheduledJobsBottomSheetTrigger.module.scss"
import { UnscheduledJobsBottomSheetTriggerProps } from "./UnscheduledJobsBottomSheetTrigger.types"

export default function UnscheduledJobsBottomSheetTrigger(props: UnscheduledJobsBottomSheetTriggerProps) {
    const { count, onClick } = props

    const triggerRef = useRef<HTMLButtonElement>(null)

    useEffect(() => {
        if (triggerRef.current) {
            const buttonTriggerHeight = triggerRef.current.offsetHeight

            const root = document.documentElement
            root.style.setProperty("--unscheduled-jobs-bottom-sheet-trigger-height", `${buttonTriggerHeight}px`)
        }

        return () => {
            const root = document.documentElement
            root.style.setProperty("--unscheduled-jobs-bottom-sheet-trigger-height", `0`)
        }
    }, [triggerRef])

    return (
        <button ref={triggerRef} className={styles.base} onClick={onClick} aria-label="Unscheduled Jobs">
            <Icon icon={faIcon({ name: "angles-up", style: "regular" })} className={styles.icon} />
            <div className={styles.headingAndCounter}>
                <div className={styles.heading}>{count} Unscheduled Jobs</div>
            </div>
            <Icon icon={faIcon({ name: "angles-up", style: "regular" })} className={styles.icon} />
        </button>
    )
}
